const locationSlides = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {



    let sW = window.innerWidth;
    let sH = window.innerHeight;

    const secSlides = document.getElementById('jsSecSlides');
    // const slideWrap = secDesign1.querySelector('.js-slide-wrap');
    // const jsSwiper = slideWrap.querySelector('.js-swiper');
    // const swiperBtnPrev = slideWrap.querySelector('.js-swiper-btn-prev');


    const slideWrap = secSlides.querySelectorAll('.js-slide-wrap');


    slideWrap.forEach(element => {

      const wrapper = element.querySelector('.js-ul');
      const wrapperWidth = wrapper.offsetWidth;
      const slides = element.querySelectorAll('.js-li');
      console.log(slides)

      let to1 = gsap.to(slides, {
        xPercent: -100 * (slides.length - 1),
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: wrapper,
          pin: true,
          scrub: 1.5,
          start: "top top",
          end: `+=${wrapperWidth}`,
          // onUpdate: function (self) { // スクロール位置に応じて処理を行う
          //   var progress = self.progress; // 進行状況を取得
          //   var currentIndex = Math.round(progress * (slides.length - 1)); // 現在のスライドを取得

          //   slides.forEach(function (slide, index) { // 任意のクラスを付与
          //     if (index === currentIndex) {
          //       slide.classList.add("act");
          //     } else {
          //       slide.classList.remove("act");
          //     }
          //   });
          // },
        },
      });


      let wrapperH = wrapper.clientHeight;
      const copyBox = element.querySelector('.js-copy-box');

      let to2 = gsap.to(slides, {
        // xPercent: -100 * (slides.length - 1),
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: copyBox,
          pin: true,
          scrub: 1,
          start: `bottom ${wrapperH}px`,
          end: `+=${wrapperWidth}`,
          // markers: true,
        },
      });


      const numBox = element.querySelector('.js-num-box');

      let to3 = gsap.to(slides, {
        // xPercent: -100 * (slides.length - 1),
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: numBox,
          pin: true,
          scrub: 1,
          start: "top top",
          end: `+=${wrapperWidth}`,
          // markers: true,
        },
      });


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to1.scrollTrigger.refresh()
          to2.scrollTrigger.refresh()
          to3.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);

    });




  }
})()
export default locationSlides;